<template>
  <v-flex xs12 row>
    <v-layout py-3>
   		<v-flex xs12>
   			<v-form v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              
              <v-flex xs6 sm3>
                <div class="subheading text-uppercase font-weight-light">
                  <span>Stock Movement ID: </span>
                  <span>{{movement.id}}</span>
                </div>
              </v-flex>

              <v-flex xs12 sm6 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4" v-text="`${pageType} Stock Movement`"></span>
              </v-flex>

              <v-flex xs6 sm3 class="text-xs-right">
                <div class="body-2 font-weight-light py-2">
                  <v-icon class="mr-1">date_range</v-icon>
                  <span>{{movement.date}}</span>
                </div>
              </v-flex>
              
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md class="grey lighten-5">
                
                <v-layout wrap>
                  
                  <v-flex xs12 sm4>
                    <v-autocomplete v-model="movement.warehouse_from_id" :items="warehouses" item-text="title" item-value="id" label="Movement From" :readonly="viewMode"></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm4>
                    <v-autocomplete v-model="movement.warehouse_to_id" :items="warehousesTo" item-text="title" item-value="id" label="Movement To" :readonly="viewMode"></v-autocomplete>
                  </v-flex>

                </v-layout>

              </v-container>

              <v-container grid-list-md py-0 v-if="!viewMode">

                <v-layout wrap>
                  <v-flex xs12 sm3>
                    <v-autocomplete :loading="itemLoading" v-model="itemId" :search-input.sync="itemCodeSearch" :items="searchItems" item-text="item_code" item-value="id" label="Search Item Code" hide-no-data :disabled="!movement.warehouse_from_id">
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.item_code"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-autocomplete :loading="itemLoading" v-model="itemId" :search-input.sync="itemNameSearch" :items="searchItems" item-text="title" item-value="id" label="Search Item Name" hide-no-data :disabled="!movement.warehouse_from_id">
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Code</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Stock QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="movement.items && movement.items.length > 0">
                            <tr is="stock-movement-item" v-for="(item, index) in movement.items" v-bind:item="item" v-bind:index="index" v-on:delete="deleteItem" :viewMode="viewMode"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!viewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" to="/stock-movement-list">Cancel</v-btn>
              <v-btn color="blue darken-1" flat :disabled="!validForm || processing || !hasEnoughStock" :loading="processing" @click.native="upsertStockMovement" v-text="movement.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>
  
  import StockMovementItem from './StockMovementItem'

  export default {
    name: 'StockMovement',
    props: {
      viewMode: {
        default: false
      }
    },
    data () {
      return {
      	title: "Stock Movement",
        validForm: false,
      	processing: false,
        itemLoading: false,
        itemNameLoading: false,
        warehouses: [],
        warehousesTo: [],
        itemId: null,
        itemCodeSearch: "",
        itemNameSearch: "",
        searchItems: [],
        movement: {},
        defaultMovement: {
          id: "",
          date: this.today('YYYY-MM-DD'),
          warehouse_from_id: null,
          warehouse_to_id: null,
          items: []
        }

      }
    },
    created () {

      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Stock Movement',
            disabled: false,
            href: '/stock-movement-list'
	        },
	        {
	          text: this.pageType,
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Stock Movement')
    },
    methods: {

      searchItemsByParam (key, val) {

        this.itemLoading = true
        this.axios.get(`${this.config.apis.searchItems}?${key}=${val}&stock=true&warehouse=${this.movement.warehouse_from_id}&include_parent=true`)
        .then((response) => {
            this.itemLoading = false
            if (this.isSuccessResponse(response)) {
              this.searchItems = response.data.data
            }
        })
        .catch((error) => {
            this.itemLoading = false
        })
      },

      searchItemsByCode () {
        this.searchItemsByParam('item_code', this.itemCodeSearch)
      },

      searchItemsByName () {
        this.searchItemsByParam('title', this.itemNameSearch)
      },

      upsertItemFromListToMovement (val) {

        let exist = this.movement.items.findIndex(item => item.item_id === val)

        // if item already exists, then increase quantity else add new item
        if (exist == -1) {
          let item = this.searchItems.filter(item => item.id === val)

          if (item.length > 0) {
            //add new item at the first index of items array
            let new_item = this.extend({quantity:1, item_id: item[0].id}, item[0])
            delete new_item.id
            this.movement.items.splice(0, 0, new_item)
            
          }
        }

        this.clearItemAutoComplete()

      },

      clearItemAutoComplete () {
        this.itemCodeSearch = ""
        this.itemNameSearch = ""
        setTimeout(() => {
          this.itemId = null
        }, 100)
      },

      upsertStockMovement () {

        if (this.movement.items.length === 0) return this.notifyError('emptyStockMovementItems')
        if (!this.movement.warehouse_from_id || !this.movement.warehouse_to_id) return this.notifyError('emptyStockMovementWarehouse')

        this.processing = true

        let data = this.extend(this.movement)

        let method = data.id ? 'put' : 'post'
        let api_path = data.id ? this.config.apis.updateStockMovement.replace(":id", data.id) : this.config.apis.saveStockMovement

        this.axios[method](api_path, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let successStatus = data.id ? 'updateStockMovementSuccess' : 'insertStockMovementSuccess'

              this.notifySuccess(successStatus)
              this.$router.push("/stock-movement-list")
            }
            else{

              let errorStatus = data.id ? 'updateError' : 'insertError'

              this.notifyError(errorStatus)
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.movement.items.splice(index, 1)
      },

      initNewStockMovement () {
        this.movement = this.extend({}, this.defaultMovement)
      },

      loadStockMovement (id) {
        this.processing = true
        
        let api_path = this.config.apis.getStockMovement.replace(":id", id)

        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.movement = response.data.data
            }
            else{
              this.movement = this.initNewStockMovement()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },

    mounted () {

      this.getAllData('warehouse')
        .then((response) => {
          this.warehouses = response
          this.warehousesTo = this.movement && this.movement.warehouse_from_id ? 
                                this.warehouses.filter(item => item.id != this.movement.warehouse_from_id) : response
          
        })

      if (this.$route.params.id) {
        this.loadStockMovement(this.$route.params.id)
      }
      else{
        this.initNewStockMovement()
      }
      
    },

    computed: {

      pageType () {
        
        let title = "Add"
        
        if (this.viewMode) {
          title = "View"
        }
        else if(this.$route.params.id) {
          title = "Edit"
        }

        return title

      },

      hasEnoughStock () {
        
        if (!this.movement.items) return false

        let stockLessItems = this.movement.items.filter( item => item.quantity > item.stock_quantity )

        return stockLessItems.length > 0 ? false : true

      }

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.id) {
          this.loadStockMovement(to.params.id)
        }
        else{
          this.movement = this.initNewStockMovement()
        }

      },

      itemCodeSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByCode()
        }
      },

      itemNameSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByName()
        }
      },

      itemId (val, oldVal) {
        if (val && val !== oldVal) {
          this.upsertItemFromListToMovement(val)
        }
      },

      'movement.warehouse_from_id' (val, oldVal) {

        if (val && !this.viewMode) {
          
          if (oldVal) {
            this.movement.items = []
            this.movement.warehouse_to_id = null
          }
          
          this.warehousesTo = this.warehouses.filter(item => item.id != val)
        }
      }

    },
    
    components: {
      'stock-movement-item': StockMovementItem
    }

  }
</script>
